var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _radialGradient2, _linearGradient14, _linearGradient15, _linearGradient16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThermometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 153.6088001214,
    cy: 136.8550486088,
    gradientUnits: "userSpaceOnUse",
    r: 309.7956719388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7282,
    stopColor: "#e3f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#d8ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9756,
    stopColor: "#c7e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 502.1362847812,
    x2: 177.2947334362,
    y1: 330.6624918854,
    y2: 245.842929165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2926,
    stopColor: "#e6f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6915,
    stopColor: "#d4eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 512 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 190.1205,
    x2: 343.8459,
    xlinkHref: "#c",
    y1: 255,
    y2: 255
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 191.8832259792,
    x2: 343.8017226292,
    xlinkHref: "#c",
    y1: 256.00011,
    y2: 256.00011
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 331.29426,
    x2: 219.840847404,
    xlinkHref: "#c",
    y1: 255.497647039,
    y2: 255.497647039
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 281.09816,
    x2: 217.7237766904,
    xlinkHref: "#g",
    y1: 255.497647039,
    y2: 255.497647039
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 118.462796,
    y2: 118.462796
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 163.973592026,
    y2: 163.973592026
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 209.485391974,
    y2: 209.485391974
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 254.996188,
    y2: 254.996188
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 300.506984026,
    y2: 300.506984026
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 299.168756,
    x2: 338.657023948,
    xlinkHref: "#g",
    y1: 346.018783974,
    y2: 346.018783974
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 127.4977928234,
    cy: 270.0737913414,
    gradientUnits: "userSpaceOnUse",
    r: 249.8432571584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2336,
    stopColor: "#ff6b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#ff6143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#ff504e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7434,
    stopColor: "#ff395e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    stopColor: "#ff1b72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0084"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 257.3236807648,
    x2: 166.177200816,
    xlinkHref: "#p",
    y1: 298.615594978,
    y2: 254.5365925084
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 264.1749464538,
    x2: 147.2172303162,
    xlinkHref: "#p",
    y1: 410.1570515334,
    y2: 477.4202271022
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 19.589844c-51.144531 0-92.605469 41.460937-92.605469 92.605468v287.609376c0 27.179687 11.707031 51.625 30.355469 68.566406l42.90625 42.90625c6.386719.476562 12.835938.722656 19.34375.722656 141.382812 0 256-114.617188 256-256 0-6.507812-.246094-12.957031-.722656-19.34375l-186.710938-186.710938c-16.941406-18.648437-41.386718-30.355468-68.566406-30.355468zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 492.410156c51.144531 0 92.605469-41.460937 92.605469-92.605468v-287.609376c0-51.144531-41.460938-92.605468-92.605469-92.605468s-92.605469 41.460937-92.605469 92.605468v287.609376c0 51.144531 41.460938 92.605468 92.605469 92.605468zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 488.71875c-50.347656 0-91.160156-40.8125-91.160156-91.160156v-283.117188c0-50.347656 40.8125-91.160156 91.160156-91.160156s91.160156 40.8125 91.160156 91.160156v283.117188c0 50.347656-40.8125 91.160156-91.160156 91.160156zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m256.054688 477.867188c-16.710938-.003907-32.542969-6.605469-44.582032-18.597657-12.070312-12.023437-18.71875-27.882812-18.71875-44.648437 0-17.761719 7.539063-34.804688 20.683594-46.769532 2.804688-2.554687 4.414062-6.253906 4.414062-10.148437v-286.425781c0-21.035156 17.113282-38.148438 38.148438-38.148438.351562 0 .707031.003906 1.0625.015625 20.453125.558594 37.085938 17.929688 37.085938 38.71875v285.835938c0 3.914062 1.554687 7.566406 4.265624 10.015625 13.238282 11.976562 20.832032 29.070312 20.832032 46.90625 0 16.53125-6.335938 32.167968-17.84375 44.03125-11.480469 11.835937-26.871094 18.648437-43.324219 19.179687-.675781.023438-1.351563.035157-2.023437.035157zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m284.109375 357.699219v-285.835938c0-15.316406-12.007813-28.261719-27.320313-28.683593-15.882812-.4375-28.898437 12.3125-28.898437 28.097656v286.429687c0 6.671875-2.761719 13.074219-7.695313 17.566407-10.691406 9.730468-17.402343 23.753906-17.402343 39.347656 0 29.730468 25.242187 54.140625 54.957031 53.179687 28.578125-.925781 51.457031-24.378906 51.457031-53.179687 0-15.65625-6.765625-29.726563-17.527343-39.460938-4.90625-4.4375-7.570313-10.84375-7.570313-17.460937zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 122.476562h-31.457031c-2.21875 0-4.015625-1.796874-4.015625-4.015624 0-2.214844 1.796875-4.015626 4.015625-4.015626h31.457031c2.21875 0 4.015625 1.800782 4.015625 4.015626 0 2.21875-1.796875 4.015624-4.015625 4.015624zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 167.988281h-31.457031c-2.21875 0-4.015625-1.796875-4.015625-4.015625s1.796875-4.015625 4.015625-4.015625h31.457031c2.21875 0 4.015625 1.796875 4.015625 4.015625s-1.796875 4.015625-4.015625 4.015625zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 213.5h-31.457031c-2.21875 0-4.015625-1.796875-4.015625-4.015625 0-2.214844 1.796875-4.015625 4.015625-4.015625h31.457031c2.21875 0 4.015625 1.800781 4.015625 4.015625 0 2.21875-1.796875 4.015625-4.015625 4.015625zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 259.011719h-31.457031c-2.21875 0-4.015625-1.796875-4.015625-4.015625s1.796875-4.015625 4.015625-4.015625h31.457031c2.21875 0 4.015625 1.796875 4.015625 4.015625s-1.796875 4.015625-4.015625 4.015625zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 304.523438h-31.457031c-2.21875 0-4.015625-1.800782-4.015625-4.015626 0-2.21875 1.796875-4.015624 4.015625-4.015624h31.457031c2.21875 0 4.015625 1.796874 4.015625 4.015624 0 2.214844-1.796875 4.015626-4.015625 4.015626zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m334.640625 350.035156h-31.457031c-2.21875 0-4.015625-1.800781-4.015625-4.015625 0-2.21875 1.796875-4.015625 4.015625-4.015625h31.457031c2.21875 0 4.015625 1.796875 4.015625 4.015625 0 2.214844-1.796875 4.015625-4.015625 4.015625zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m284.109375 357.699219v-121.769531c0-15.316407-12.007813-28.261719-27.320313-28.683594-15.882812-.433594-28.898437 12.3125-28.898437 28.101562v122.359375c0 6.671875-2.761719 13.074219-7.695313 17.566407-10.691406 9.730468-17.402343 23.753906-17.402343 39.347656 0 29.730468 25.242187 54.140625 54.957031 53.179687 28.578125-.925781 51.457031-24.378906 51.457031-53.179687 0-15.65625-6.765625-29.726563-17.527343-39.460938-4.90625-4.4375-7.570313-10.84375-7.570313-17.460937zm0 0",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m278.085938 373.457031h-44.171876v-137.105469c0-12.199218 9.886719-22.085937 22.085938-22.085937s22.085938 9.886719 22.085938 22.085937zm0 0",
    fill: "url(#q)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m303.980469 414.859375c0 26.496094-21.480469 47.980469-47.980469 47.980469s-47.980469-21.484375-47.980469-47.980469c0-26.5 21.480469-47.980469 47.980469-47.980469s47.980469 21.480469 47.980469 47.980469zm0 0",
    fill: "url(#r)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThermometer);
export default __webpack_public_path__ + "static/media/icon-thermometer.1a1981febff5a9652c8ea8fbd8063dcc.svg";
export { ForwardRef as ReactComponent };